import React, { useState, useEffect } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import soundManager from '../../utils/SoundManager';

const SoundControl = () => {
  const [soundEnabled, setSoundEnabled] = useState(soundManager.enabled);

  useEffect(() => {
    soundEnabled ? soundManager.enable() : soundManager.disable();
  }, [soundEnabled]);

  const handleToggle = () => {
    setSoundEnabled((prev) => !prev);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Tooltip title={soundEnabled ? "Disable Sound" : "Enable Sound"}>
        <IconButton onClick={handleToggle}>
          {soundEnabled ? <VolumeUpIcon /> : <VolumeOffIcon />}
        </IconButton>
      </Tooltip>

    </div>
  );
};

export default SoundControl;